export class KeyValuePair<TKey, TValue> {
    // data members

    key: TKey;
    value: TValue;

    // constructor

    constructor(key: TKey, value: TValue) {
        this.key = key;
        this.value = value;
    }
}
